import { render, staticRenderFns } from "./ParticaArticleExtract.vue?vue&type=template&id=328e5570&scoped=true&"
import script from "./ParticaArticleExtract.vue?vue&type=script&lang=ts&"
export * from "./ParticaArticleExtract.vue?vue&type=script&lang=ts&"
import style0 from "./ParticaArticleExtract.vue?vue&type=style&index=0&id=328e5570&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "328e5570",
  null
  
)

export default component.exports